import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText';

import ActionLink from '../builder/ActionLink';

const CustomTerms = (props) => {
	const show_ep = props?.show_ep ?? false;
	let ep_footer_link = false;

	if(show_ep) {
		ep_footer_link = window.web_base_url;
		if(window.is_spanish) ep_footer_link += `/es/`;
		ep_footer_link += `?utm_source=Easypromos&utm_medium=body&utm_campaign=termsandconditionspage`;
	}

	return (
		<div class="layout_conts">
			<div class="flex_cols">
				<div class="flex_col col_2">
					<article class="promo_desc gui_main_text_color_on_bg main_text_flex">
						{(props.term.title != "") && (
							<LeveledHTMLText
								_class={{ other:'promotion_title' }}
							>{props.term.title}</LeveledHTMLText>
						)}

						{(props.term.text != "") && (
							<LeveledHTMLText
								_class={{ other:'fill_description' }}
							>{props.term.text}</LeveledHTMLText>
						)}

						{(ep_footer_link !== false) && (
							<p class="ep_notification gui_text_block">
								<FormattedMessage id="These legal bases are hosted at {link}." values={{link:<ActionLink _href={ep_footer_link} _nofollow='nofollow' autotranslate={false}>Easypromos</ActionLink>}} />
							</p>
						)}
					</article>
				</div>
			</div>
		</div>
	)
}

export default injectIntl(CustomTerms);